package games.polyclub.website.frontend.store.pages

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.h2
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val GiftTermsPage = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.GIFT_TERMS.pathPart, -"Termos e Condições para Compras de Presentes")

    PageHeader {
        title = -"Termos e Condições para Compras de Presentes na PolyClub"
    }
    PageBody {
        Card {
            h2 {
                +"1. Introdução"
            }
            p {
                +"Bem-vindo aos Termos e Condições para Compras de Presentes na PolyClub. Este documento descreve as diretrizes que regem as compras de presentes em nossa plataforma. Ao utilizar nosso sistema de compras de presentes, você concorda em cumprir os termos abaixo."
            }

            h2 {
                +"2. Funcionamento do Sistema de Compras de Presentes"
            }
            p {
                +"O sistema de compras de presentes da PolyClub permite que o comprador escolha um presente e selecione o destinatário no momento da compra. O presenteado receberá o presente no ato do pagamento, e o comprador poderá visualizar um histórico da transação, confirmando que a compra foi efetuada e o presente foi entregue à pessoa designada."
            }

            h2 {
                +"3. Direitos e Responsabilidades do Comprador"
            }
            p {
                +"O comprador compromete-se a utilizar o sistema de compras de presentes da PolyClub de forma ética e legal. O comprador não pode utilizar essa funcionalidade com o intuito de revenda, especulação ou qualquer outra atividade inadequada."
            }

            h2 {
                +"4. Mensagens Personalizadas em Presentes"
            }
            p {
                +"Oferecemos a opção de incluir mensagens personalizadas ao comprar um presente em nossa loja. Essa funcionalidade permite que você adicione uma mensagem especial que será entregue juntamente com o presente ao destinatário. Certifique-se de utilizar essa opção de forma respeitosa e evite conteúdo ofensivo ou inadequado. Reservamo-nos o direito de moderar ou remover mensagens que violem nossas diretrizes de uso."
            }

            h2 {
                +"5. Política de Cancelamento de Compras de Presentes"
            }
            p {
                +"É importante observar que, uma vez efetuada a compra de um presente, não é possível cancelá-la. Esta política visa evitar o uso abusivo do sistema de compras de presentes."
            }

            h2 {
                +"6. Medidas Disciplinares"
            }
            p {
                +"A PolyClub se reserva o direito de tomar medidas disciplinares contra compradores que façam uso abusivo do sistema de compras de presentes. Isso pode incluir a suspensão ou exclusão da conta do comprador. Nosso objetivo é manter um ambiente seguro e justo para todos os usuários."
            }

            h2 {
                +"7. Contato e Suporte"
            }
            p {
                +"Se você tiver alguma dúvida ou precisar de assistência relacionada às compras de presentes, mensagens personalizadas, entre em contato conosco por meio dos canais de suporte fornecidos em nosso site."
            }

            p {
                +"Agradecemos por utilizar o sistema de compras de presentes na PolyClub e contamos com sua colaboração para manter um ambiente respeitoso e ético."
            }
        }
    }
}
